import React, { useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import {
  Card,
  CardTitle,
  CardBody,
  CardActions,
  CardSubtitle,
} from "@progress/kendo-react-layout";
import { dateFormat } from "../../services/shareconstant";
import { Label } from "@progress/kendo-react-labels";
import { Notification } from "@progress/kendo-react-notification";
import { STATUS } from "../../model/constants";
import { PostSave } from "../../services/useFetch";
import { urlEnrollmentSave } from "../../services/serviceURLs";
import Spinner from "../Spinner";
import CoverageCard from "./CoverageCard";
import { useHistory } from "react-router-dom";
import {
  redirectHome,
  errorSaveMessage,
  SuccessSaveMessage,
  undoMessage1,
  undoMessage2,
} from "../../services/shareconstant";

export default function PendingCancellations(props) {
  const [openCancelForm, setOpenCancelForm] = useState(false);
  const [cancelCard, setCancelCard] = useState({});
  const [status, setStatus] = useState(STATUS.IDLE);
  const [saveError, setSaveError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [electionMsg, setElectionMsg] = useState(``);

  const cancelClick = (card) => {
    setCancelCard(card);
    setOpenCancelForm(true);
  };

  const toggleDialog = () => {
    setOpenCancelForm(!openCancelForm);
  };

  const onCancelConfirm = async () => {
    try {
      setOpenCancelForm(false);
      setCancelCard({});
      setStatus(STATUS.SUBMITTING);
      const saveElection = {
        electionType: `CancelPending`,
        insuranceElectionID: cancelCard.insuranceElectionID,
        insuranceID: cancelCard.insuranceID,
      };
      const saveresponse = await PostSave(
        `${urlEnrollmentSave}`,
        `POST`,
        saveElection
      );
      setSaveError(null);
      if (saveresponse.ok) {
        const electionresult = await saveresponse.json();
        setElectionMsg(electionresult.Message);
        setSuccess(true);
        setError(false);
        setStatus(STATUS.COMPLETED);
      } else {
        throw saveresponse;
      }
    } catch (e) {
      setSaveError(e.statusText);
      setStatus(STATUS.ERROR);
      setSuccess(false);
      setError(true);
    }
  };

  const history = useHistory();
  function handleCloseDialog() {
    history.push(redirectHome);
  }

  return (
    <>
      {status === STATUS.SUBMITTING && <Spinner />}

      {(success || error) && (
        <Dialog onClose={handleCloseDialog}>
          {success && electionMsg === "Cancelled" && (
            <Notification
              type={{ style: "success", icon: true }}
              closable={false}
            >
              <span>{SuccessSaveMessage}</span>
            </Notification>
          )}
          {error && (
            <Notification
              type={{ style: "error", icon: true }}
              closable={false}
            >
              <span>
                {errorSaveMessage} {saveError}
              </span>
            </Notification>
          )}
          <DialogActionsBar>
            <button className="k-button" onClick={handleCloseDialog}>
              OK
            </button>
          </DialogActionsBar>
        </Dialog>
      )}

      {openCancelForm && (
        <Dialog
          className="confirmUndo"
          title={"Confirm Undo"}
          onClose={toggleDialog}
        >
          <p>{undoMessage1} </p>
          <CardSubtitle>
            {cancelCard.insurancePlanTypeDescription}.
          </CardSubtitle>
          <p>{undoMessage2} </p>
          <DialogActionsBar>
            <Button themeColor="primary" onClick={onCancelConfirm}>
              {" "}
              Confirm
            </Button>
            <Button themeColor="secondary" onClick={toggleDialog}>
              {" "}
              Cancel
            </Button>
          </DialogActionsBar>
        </Dialog>
      )}

      {props.pendingCancellations.map((card, index) => {
        return (
          <div key={index} className="card-items">
            <Card>
              <div>
             
                <CardBody>
                  {/* <CardSubtitle>Pending terminations ALPAIN-63 -PendingTerminations  </CardSubtitle> */}
                  <CardTitle>
                  {card.insuranceID >= 0 ? (
                    <p className="text-ellipsis description-block">
                      {card.insurancePlanTypeDescription} ID #{card.insuranceID}
                    </p>
                  ) : (
                    <p className="text-ellipsis description-block">
                      {card.insurancePlanTypeDescription}
                    </p>
                  )}
                    {card.nonContributoryOptIn === true &&
                    JSON.parse(localStorage.getItem("showApprentice")) === true
                      ? ` (Apprentice)`
                      : null}
                  </CardTitle>                  
                  <p className="startDate-label">
                    Start Date: {dateFormat(card.startDate)}
                  </p>
                  <CoverageCard card={card} />
                </CardBody>
                <CardActions>
                  <div className="pending-action">
                    <Label style={{ color: "Red" }}>
                      {" "}
                      Unsubmitted Termination
                    </Label>
                  </div>
                  <div className="main-action">
                    <Button
                      themeColor="primary"
                      fillMode="flat"
                      onClick={() => cancelClick(card)}
                    >
                      Undo{" "}
                    </Button>
                  </div>
                </CardActions>
              </div>
            </Card>
          </div>
        );
      })}
    </>
  );
}
